function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7.875,
  y: 5.4375,
  width: 13.8125,
  height: 14.625,
  rx: 2,
  stroke: "#3D7DF8",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.82008 5.26588L13.0076 4.07497C13.7616 3.96529 14.4375 4.54999 14.4375 5.31196V20.188C14.4375 20.95 13.7616 21.5347 13.0076 21.425L4.82007 20.2341C4.20568 20.1448 3.75 19.618 3.75 18.9971V6.50286C3.75 5.88201 4.20568 5.35525 4.82008 5.26588Z",
  fill: "white",
  stroke: "#3D7DF8",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09723 10.3334C9.1622 10.3334 9.22254 10.345 9.27823 10.3682C9.33624 10.3914 9.38729 10.4239 9.43138 10.4657C9.47779 10.5052 9.51724 10.5539 9.54972 10.612C9.58221 10.6677 9.60542 10.728 9.61934 10.793L10.218 13.5718H10.3364C10.4338 13.1191 10.5336 12.6571 10.6357 12.1859C10.7378 11.7123 10.8399 11.248 10.942 10.793C10.9629 10.7048 10.9942 10.6247 11.036 10.5528C11.0731 10.4924 11.1242 10.4379 11.1891 10.3891C11.2564 10.338 11.3435 10.3125 11.4502 10.3125C11.5314 10.3125 11.6022 10.3276 11.6625 10.3578C11.7252 10.3856 11.7762 10.4228 11.8157 10.4692C11.8574 10.5133 11.8876 10.5621 11.9062 10.6154C11.9271 10.6688 11.9375 10.7211 11.9375 10.7721C11.9375 10.8 11.9363 10.8267 11.934 10.8522C11.9317 10.8778 11.9282 10.8998 11.9236 10.9184C11.9189 10.9416 11.9143 10.9625 11.9097 10.9811L10.9559 14.7696C10.9211 14.8486 10.8747 14.9182 10.8167 14.9786C10.768 15.032 10.7042 15.0807 10.6253 15.1248C10.5487 15.1666 10.4524 15.1875 10.3364 15.1875H10.218C10.102 15.1875 10.0069 15.1666 9.9326 15.1248C9.85835 15.0807 9.79918 15.032 9.75509 14.9786C9.70404 14.9182 9.66575 14.8486 9.64022 14.7696L9.15292 12.7291H9.03458C8.96032 13.0587 8.88027 13.3988 8.79441 13.7494C8.71087 14.0999 8.63081 14.44 8.55424 14.7696C8.52407 14.8486 8.48346 14.9182 8.43241 14.9786C8.386 15.032 8.32567 15.0807 8.25142 15.1248C8.17948 15.1666 8.0855 15.1875 7.96948 15.1875H7.85113C7.73511 15.1875 7.63649 15.1666 7.55527 15.1248C7.47637 15.0807 7.4114 15.032 7.36035 14.9786C7.30002 14.9182 7.25245 14.8486 7.21764 14.7696L6.27785 10.9811C6.2732 10.9625 6.26856 10.9416 6.26392 10.9184C6.25928 10.8998 6.2558 10.8778 6.25348 10.8522C6.25116 10.8267 6.25 10.8 6.25 10.7721C6.25 10.7211 6.25928 10.6688 6.27785 10.6154C6.29873 10.5621 6.3289 10.5133 6.36834 10.4692C6.41011 10.4228 6.46116 10.3856 6.5215 10.3578C6.58415 10.3276 6.65608 10.3125 6.7373 10.3125C6.84404 10.3125 6.9299 10.338 6.99487 10.3891C7.06217 10.4379 7.11438 10.4924 7.15151 10.5528C7.19328 10.6247 7.2246 10.7048 7.24549 10.793L7.85113 13.5718H7.96948C8.01357 13.3582 8.06114 13.1342 8.11219 12.8997C8.16324 12.6629 8.21429 12.425 8.26534 12.1859C8.31871 11.9445 8.37092 11.7065 8.42197 11.4721C8.47534 11.2353 8.52639 11.0089 8.57512 10.793C8.60761 10.6607 8.67026 10.5516 8.76308 10.4657C8.8559 10.3775 8.96728 10.3334 9.09723 10.3334Z",
  fill: "#3D7DF8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9688 9.5H21.875",
  stroke: "#3D7DF8",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9688 12.75H21.875",
  stroke: "#3D7DF8",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9688 16H21.875",
  stroke: "#3D7DF8",
  strokeWidth: 1.5
});

var SvgWord = function SvgWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/word.b213df52.svg";
export { ForwardRef as ReactComponent };